module.exports = __webpack_public_path__ + "static/img/blog_1.d008898.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/blog_1.jpg
// module id = k9U0
// module chunks = 0